import { useState } from "react";
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import moment from "moment";
import { IoMdArrowDropdownCircle, IoMdArrowDropupCircle  } from "react-icons/io";

import ExpandablePanel from '../../components/ExpandablePanel';
import { deadlineStatus, isTaskCancelled, isTaskFinished, taskSizesEnum, taskStatusEnum, toolbarActions  } from '../../services/EnumsService';
import { taskOrderDown, taskOrderUp, taskStart, taskCancel, taskFinish } from "../../api/tasks.api";
import ToolbarComponent from '../toolbar/ToolbarComponent';
import ToolbarOptionComponent from '../toolbar/ToolbarOptionComponent';
import { TaskModal } from '../Task/TaskModal';
import { SubtaskModal } from "../Subtask/SubtaskModal";
import ExpandableSubtaskComponent from "../Subtask/ExpandableSubtaskComponent";
import { WorklogModal } from "../Worklog/WorklogModal";
import WorklogComponent from "../Worklog/WorklogComponent";
import TaskResourceModal from './TaskResourceModal';
import TaskResourceComponenet from './TaskResourceComponent'
import { showError } from "../../services/toastServices";
import { CategoryData } from "../../pages/Category/CategoryWrapper";
import { BulkSubtaskModal } from "../Subtask/BulkSubtaskModal";

export default function ExpandableTaskComponent({task, isFirst, isLast}) {
    const [showTaskModal, setShowTaskModal] = useState(false)
    const [showSubtaskModal, setShowSubtaskModal] = useState(false)
    const [showBulkSubtasksModal, setShowBulkSubtasksModal] = useState(false)
    const [showWorklogModal, setShowWorklogModal] = useState(false)
    const [showTaskResourceModal, setShowTaskResourceModal] = useState(false)
    const {category, refreshProjectsCategory} = CategoryData();
    

    const editTaskAction = (()=>{
        setShowTaskModal(true)
    })
    const editTaskCloseAction = (()=>{
        setShowTaskModal(false)
    })
    const createSubtaskAction = (()=>{
        setShowSubtaskModal(true)
    })
    const bulkCreateSubtaskAction = (()=>{
        setShowBulkSubtasksModal(true)
    })

    const createSubtaskCloseAction = (()=>{
        setShowSubtaskModal(false)
    })
    const bulkCreateSubtaskCloseAction = (()=>{
        setShowBulkSubtasksModal(false)
    })

    const createWorklogAction = (()=>{
        setShowWorklogModal(true)
    })
    const createWorklogCloseAction = (()=>{
        setShowWorklogModal(false)
    })

    const createTaskResourceAction = (()=>{
        setShowTaskResourceModal(true)
    })
    const createTaskResourceCloseAction = (()=>{
        setShowTaskResourceModal(false)
    })
    const startTaskAction =(async ()=>{
        await taskStart(task.id, changeStatusError)
        refreshProjectsCategory();
    })

    const finishTaskAction =(async ()=>{
        await taskFinish(task.id, changeStatusError)
        refreshProjectsCategory();
    })

    const cancelTaskAction =(async ()=>{
        await taskCancel(task.id, changeStatusError)
        refreshProjectsCategory();
    })


    const editTaskModal = (<TaskModal taskId={task.id} closeAction={editTaskCloseAction}></TaskModal>)
    const addSubtaskModal = (<SubtaskModal task={task} closeAction={createSubtaskCloseAction}></SubtaskModal>)
    const bulkAddSubtaskModal = (<BulkSubtaskModal task={task} closeAction={bulkCreateSubtaskCloseAction}></BulkSubtaskModal>)
    const addWorklogModal = (<WorklogModal task={task} closeAction={createWorklogCloseAction}></WorklogModal>)
    const addTaskResourceModal = (<TaskResourceModal task={task} closeAction={createTaskResourceCloseAction}></TaskResourceModal>)

    const getDeadlineColor = (()=>{
        return deadlineStatus((moment(task.deadline).isAfter()))
    })

    const orderUp = (async ()=>{
        await taskOrderUp(task.id, orderError);
        refreshProjectsCategory();
    })

    const orderDown = (async ()=>{
        await taskOrderDown(task.id, orderError);
        refreshProjectsCategory();
    })

    const orderError = ((error)=>{
        showError(`Error al cambiar el orden de la tarea. ${error.message}`)

    })
    const changeStatusError = ((error)=>{
        showError(`Error al cambiar el estado de la tarea. ${error.message}`)

    })

    const renderUpButton = (()=>{
        if(isFirst)
            return (<div className="text-xl font-bold"><IoMdArrowDropupCircle color="gray"  /> </div>)
        else
            return (<div className="text-xl font-bold cursor-pointer" onClick={orderUp} ><IoMdArrowDropupCircle /> </div>)
    })

    const renderDownButton = (()=>{
        if(isLast)
            return (<div className="text-xl font-bold" ><IoMdArrowDropdownCircle color="gray" /></div>)
        else
            return (<div className="text-xl font-bold cursor-pointer" onClick={orderDown} ><IoMdArrowDropdownCircle /></div>)
    })
    const renderDeadline =(()=>{
        if(isTaskFinished(task)||isTaskCancelled(task)) return
        return (<div className='text-gray-400 text-right ml-2 px-2 rounded-md' style={{backgroundColor: `${getDeadlineColor()}`}}>
            (deadline {moment(task.deadline).endOf('day').fromNow()})
        </div>)
    })

    const orderButtons = (
        <div className='flex flex-row justify-start'>
            <div className="flex flex-row mr-4">
                {renderUpButton()}
                {renderDownButton()}
            </div>
        </div>
    );

    const header = (
        <div className='flex flex-col'>
            <div className='flex flex-row justify-start text-xl'>
                <div className='px-2 rounded-md flex flex-row' style={{ backgroundColor: `${taskStatusEnum(task.status).color}`}}>
                    {task.name}
                    <div className='text-gray-400 text-right ml-2'>(#{task.subtasks.length})</div>
                    <div className='text-gray-400 text-right ml-2'>({taskSizesEnum(task.size).size})</div>
                </div>               
                
                {renderDeadline()}
                
            </div>
        </div>
      );

    const renderSubtasks = (task) => {
        if(task === undefined || task.subtasks === undefined) return
        const minOrder = Math.min(...task.subtasks.map(p=>p.order))
        const maxOrder = Math.max(...task.subtasks.map(p=>p.order))

        return task.subtasks.map((subtask) => (
            <ExpandableSubtaskComponent subtask={subtask} isFirst={subtask.order === minOrder} isLast={subtask.order === maxOrder}/>

        ))
    }

    const renderWorklogs = (task) => {
        if(task === undefined || task.worklogs === undefined) return
        return task.worklogs.map((worklog) => (
            <WorklogComponent worklog={worklog}/>
        ))
    }

    const renderResources = (task) => {
        if(task === undefined || task.resources === undefined) return
        return task.resources.map((resource) => (
            <TaskResourceComponenet taskResource={resource}/>
        ))
    }

    return (
        
        <div key={task.id}  className='bg-gray-200 rounded-lg'>
            {showTaskModal && editTaskModal}
            {showSubtaskModal && addSubtaskModal}
            {showBulkSubtasksModal && bulkAddSubtaskModal}
            {showWorklogModal && addWorklogModal}
            {showTaskResourceModal && addTaskResourceModal}
            <ExpandablePanel key={task.id} header={header} orderButtons={orderButtons}>
                <ToolbarComponent className='mb-2'>
                    <ToolbarOptionComponent title={'Editar'} size={20} icon={toolbarActions.Edit} clickAction={editTaskAction}/>
                    <ToolbarOptionComponent title={'Iniciar'} size={20} icon={toolbarActions.Start} clickAction={startTaskAction}/>
                    <ToolbarOptionComponent title={'Finalizar'} size={20} icon={toolbarActions.Finish} clickAction={finishTaskAction}/>
                    <ToolbarOptionComponent title={'Cancelar'} size={20} icon={toolbarActions.Cancel} clickAction={cancelTaskAction}/>
                </ToolbarComponent>

                <Markdown 
                className='border-l-4 pl-2 pr-2 prose max-w-full max-h-60 overflow-y-scroll mb-2'
                remarkPlugins={[remarkGfm]}
                >
                    {task.richDescription}
                </Markdown>
                <div className=''>
                    <div>
                        <div className="flex flex-row mb-2">
                            <div className='font-bold'>Subtareas</div>
                            <div className='mt-1'>
                                <ToolbarOptionComponent title={'+ Subtarea'} size={20} icon={toolbarActions.AddSubtask} clickAction={createSubtaskAction}/>
                            </div>
                            <div className="mt-1">
                                <ToolbarOptionComponent title={'+ lista de Subtareas'} size={20} icon={toolbarActions.AddBulkSubtask} clickAction={bulkCreateSubtaskAction}/>
                            </div>
                        </div>
                        {renderSubtasks(task)}
                    </div>

                    <div className="mb-2">
                        <div className="flex flex-row mb-2">
                            <div className='font-bold'>Recursos</div>
                            <div className='mt-1'>
                                <ToolbarOptionComponent title={'+ Recurso'} size={20} icon={toolbarActions.AddResource} clickAction={createTaskResourceAction}/>
                            </div>
                        </div>
                        {renderResources(task)}
                    </div>

                    <div className="mb-2">
                        <div className='flex flex-row mb-2'>
                            <div className='font-bold'>Carga de horas</div>
                            <div className="mt-1">
                                <ToolbarOptionComponent title={'+ horas'} size={20} icon={toolbarActions.AddWorklog} clickAction={createWorklogAction}/>
                            </div>
                        </div>
                        {renderWorklogs(task)}
                    </div>
                </div>
            </ExpandablePanel>
        </div>

    )
}